import React from 'react';
import PropTypes from 'prop-types';
import GoogleMapReact from 'google-map-react';

const GoogleMap = ({ children, ...props }) => (
    <GoogleMapReact
      bootstrapURLKeys={{ key: "AIzaSyBXHSp59E86WnSeyQzXZcqbz71r4C6bknw" }}
      {...props}
    >
      {children}
    </GoogleMapReact>
);

GoogleMap.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]),
};

GoogleMap.defaultProps = {
  children: null,
};

export default GoogleMap;